import { createTheme } from '@mui/material/styles';

// Colors sampled from the ShiftWave App Store screenshots: a deep navy page
// with a blue glow, white headlines, and the app's own shift colors as accents.
export const colors = {
    bg: '#070b16',
    bgRaised: '#0c1322',
    surface: '#111a2c',
    surfaceHigh: '#17223a',
    border: 'rgba(148, 170, 210, 0.14)',
    borderStrong: 'rgba(148, 170, 210, 0.28)',
    text: '#ffffff',
    textSecondary: '#aab6ca',
    textMuted: '#7c89a1',
    accent: '#3b8cff',
    accentLight: '#6aa8ff',
    glow: '#123d73',
    shift: {
        day: '#fbc02d',
        night: '#5c6bc0',
        off: '#66bb6a',
        ot: '#e53935',
        court: '#ab47bc',
        swap: '#fb8c00',
    },
};

const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: { main: colors.accent, light: colors.accentLight, contrastText: '#ffffff' },
        secondary: { main: colors.shift.day },
        background: { default: colors.bg, paper: colors.surface },
        text: { primary: colors.text, secondary: colors.textSecondary },
        divider: colors.border,
    },
    shape: { borderRadius: 14 },
    typography: {
        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        h1: { fontWeight: 800, letterSpacing: '-0.035em', lineHeight: 1.05 },
        h2: { fontWeight: 800, letterSpacing: '-0.03em', lineHeight: 1.1 },
        h3: { fontWeight: 800, letterSpacing: '-0.025em', lineHeight: 1.15 },
        h4: { fontWeight: 700, letterSpacing: '-0.02em' },
        h5: { fontWeight: 700, letterSpacing: '-0.01em' },
        h6: { fontWeight: 700 },
        button: { textTransform: 'none', fontWeight: 600 },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: { backgroundColor: colors.bg },
            },
        },
        MuiButton: {
            defaultProps: { disableElevation: true },
            styleOverrides: {
                root: { borderRadius: 999, paddingInline: 20 },
                sizeLarge: { paddingBlock: 12, paddingInline: 28, fontSize: '1rem' },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: { backgroundImage: 'none' },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    backgroundColor: colors.surface,
                    border: `1px solid ${colors.border}`,
                    boxShadow: 'none',
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: { backgroundColor: colors.bgRaised },
            },
        },
    },
});

export default theme;
